import React, { useEffect, useState } from 'react';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from '../componentes/Menu';
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CarAlumnoDatos from '../element/CarAlumnoDatos';
import CarHorasSociales from '../element/CarHorasSociales';
// Contexto
// import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
import loadMenu from '../js/main';
import Footer from '../componentes/Footer';

import '../css/styleAdmin.css';
// import { data } from 'jquery';

const AlumnosHorasSociales = () => {

    const history = useHistory();

    const [carnet, setCarnet] = useState({});
    const [horasSociales, setHorasSociales] = useState({});
    const [alumno, setAlumno] = useState({});
    const [solvencia, setSolvencia] = useState();
    let ths = 0;

    // const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    if (!datos) {
        history.push("/");
    }

    datos = JSON.parse(datos);

    if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
        if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1) {
          history.push("/");
        }
      }  

    let carnetSet = (e) => {
        setCarnet(e.target.value)
    }

    let onSutmit = (e) => {
        e.preventDefault();
        localStorage.setItem('currentCarnet', carnet);
        let hs = GetFetch.horasSociales(carnet, datos.token);
        hs.then((dataHS) => {
            if (!dataHS.length <= 0) {
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                setHorasSociales(dataHS);                
                AlumnoDatos();
            }else{
                setHorasSociales([]);
                document.getElementById('dataContenedorAlumno').style.display = 'block';
                AlumnoDatos();
                document.getElementById('ths').innerHTML = 0;
                if(localStorage.getItem('solvencia')){
                    setSolvencia('INSOLVENTE')
                    setTimeout(() => {
                      localStorage.removeItem('solvencia')
                    }, 5000);
                }
            }
        });
    }

    let AlumnoDatos = () => {
        let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
        datosAlum.then((data) => {
            if (data[0]) {
                setAlumno(data[0]);                
            }
        });
    }

    useEffect(() => {
        let currentCarnet = localStorage.getItem('currentCarnet');
        if (currentCarnet) {
            setCarnet(currentCarnet);
        }else{
            setCarnet('');
        }
        loadMenu();
        document.getElementById('textCarnet').focus();
    }, []);

    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto
                        foto={datos.carnet}
                        alt="Foto alumno"
                        tamanio="rounded" />

                    <HeaderMenu
                        carnet={datos.carnet}
                        nombre={datos.nombre}
                        perfil={datos.perfil}
                        carrera={datos.carrera}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <div className="container">
                    <h1 className="mt-4 text-center"> Alumnos horas sociales</h1>
                    <p className="text-center">Consulta de notas por alumno</p>
                    <form id='formUP' onSubmit={onSutmit} >
                        <div class="form-group">
                            <input id="textCarnet" type="text" placeholder="Carnet" className="form-control" onChange={carnetSet} autofocus value={carnet}></input>
                        </div>
                        <div className='form-group'>
                            <input type="submit" className="btn btn-primary btn-block" value="Enviar" />
                        </div>
                    </form>
                    
                            <CarAlumnoDatos
                                alumno={alumno}
                            />
                    <p className="text-right">Total de horas sociales: <small id="ths" className="display-4"></small></p>
                    {
                        horasSociales.length > 0
                            ?                            
                            horasSociales.map((element) => {
                                ths += element.horas
                                document.getElementById('ths').innerHTML = ths
                                return (
                                    <CarHorasSociales
                                        datos={element}
                                     />
                                )
                            })
                            :
                            solvencia ? <><p className="text-danger display-4">{solvencia}</p></> :
                           null
                    }
                </div>
            </div>
        </div>
    )

}

export default AlumnosHorasSociales;